import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { isEmpty } from "lodash";

import { fetchPersonalTrustpasses } from "./personalTrustpassActions";
import { fetchBusinessTrustpasses } from "./businessTrustpassActions";

import PrivateRoute from "../../utils/PrivateRoute";
import PageNotFound from "../shared/components/notices/PageNotFound";

import BusinessTrustpassInformationContainer from "./containers/business/InformationContainer";

class BusinessTrustpassRoutes extends Component {
  componentDidMount() {
    const {
      personalTrustPass,
      businessTrustPass,
      dispatch,
      user_id,
    } = this.props;

    if(isEmpty(personalTrustPass)) dispatch(fetchPersonalTrustpasses(user_id));
    if(isEmpty(businessTrustPass)) dispatch(fetchBusinessTrustpasses(user_id));
  }

  render() {
    return (
      <Switch>
        <PrivateRoute
          exact
          path="/business_trustpass/information/new"
          component={BusinessTrustpassInformationContainer}
        />
        <Route component={PageNotFound} />
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    personalTrustPass: state.personal_trustpass,
    businessTrustPass: state.business_trustpass,
    loading: state.shared.ui.loading.default,
    user_id: state.user.id,
  };
}

export default connect(mapStateToProps)(BusinessTrustpassRoutes);



// WEBPACK FOOTER //
// ./src/features/trustpass/btpRoutes.js